import React, { Component } from "react";
import { Notice, NOTICE_TYPES } from "@appcues/component-library";
import BaseModal from "components/ModalContainer/BaseModal";
import Input from "components/Common/Forms/Input";
import "components/ModalContainer/CreateSegmentModal/style.scss";

export default class CreateSegmentModal extends Component {
  constructor(props) {
    super(props);
    this.state = { name: "", error: null };
  }

  handleOK = () => {
    return new Promise((resolve, reject) => {
      const { name } = this.state;
      const {
        segments,
        createSegmentFromRule,
        stepId,
        onCreateCallback
      } = this.props;

      if (name) {
        const matchingSegment = Object.values(segments || {}).find(segment => {
          return `${segment.name}`.toLowerCase() === name.toLowerCase();
        });

        if (matchingSegment) {
          // should warn the user that a segment already exists
          const message = `A segment by the name "${name}" already exists.`;
          this.setState({ error: message });

          reject(new Error());
        } else {
          createSegmentFromRule(name, stepId);
          onCreateCallback && onCreateCallback();

          resolve();
        }
      } else {
        const message = "Please enter a name for your new segment";
        this.setState({
          error: message
        });

        reject(new Error(message));
      }
    });
  };

  handleChange = ({ target: { value } }) => {
    this.setState({ name: value });
  };

  render() {
    const { name, error } = this.state;

    return (
      <BaseModal
        title={`Create Segment`}
        okText={`Create Segment`}
        modalClass="redirect-modal"
        onClickOK={this.handleOK}
        {...this.props}
      >
        {error && <Notice type={NOTICE_TYPES.warning}>{error}</Notice>}

        <p>Please enter a name for your new segment</p>

        <Input
          type="text"
          placeholder="Activated Users"
          value={name}
          onChange={this.handleChange}
        />
      </BaseModal>
    );
  }
}
